/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Strength_Training_TermsInputs */

const en_service_type_strength_training_terms = /** @type {(inputs: Service_Type_Strength_Training_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`strength, weights, barbell, powerlifting, muscle gain, hypertrophy, gym`)
};

const pl_service_type_strength_training_terms = /** @type {(inputs: Service_Type_Strength_Training_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`siła, siłownia, ciężary, sztanga, trójbój, trójbój siłowy, powerlifting, budowa masy, mięśnie`)
};

/**
* | output |
* | --- |
* | "strength, weights, barbell, powerlifting, muscle gain, hypertrophy, gym" |
*
* @param {Service_Type_Strength_Training_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_strength_training_terms = /** @type {((inputs?: Service_Type_Strength_Training_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Strength_Training_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_strength_training_terms(inputs)
	return en_service_type_strength_training_terms(inputs)
});